import { Link } from '@inertiajs/react'
import HeaderLocaleMenu from '@/components/HeaderLocaleMenu'
import { t } from '@/lib/i18n'

// 营销页顶栏。从 Home/Index.tsx 抽出来——定价页是第二个用它的地方，
// 将来的六个切入点专页还要用六次；不抽会漂移七份。
//
// 锚点一律写**绝对形式** `/#how` 而不是 `#how`：这个组件要同时服务首页与定价页，
// 而定价页上没有那些 section。绝对形式在首页仍是同文档跳转（不会整页重载），
// 在定价页则先回首页再跳锚点——两边都对，且不需要传 prop 区分。
export default function MarketingHeader() {
  return (
    <header className="sticky top-0 z-30 bg-card/85 backdrop-blur border-b border-line">
      <div className="max-w-[1080px] mx-auto px-5 h-16 flex items-center gap-3">
        <a href="/" className="font-extrabold text-[19px] grad-text whitespace-nowrap">📦 HabitChest</a>
        <nav className="hidden md:flex items-center gap-6 ml-6 text-[15px] font-semibold text-muted">
          <a href="/#how" className="hover:text-ink">{t('home.nav.how')}</a>
          <a href="/#features" className="hover:text-ink">{t('home.nav.features')}</a>
          <a href="/#scenes" className="hover:text-ink">{t('home.nav.scenes')}</a>
          <a href="/#mechanism" className="hover:text-ink">{t('home.nav.mechanism')}</a>
          <Link href="/pricing" className="hover:text-ink">{t('home.nav.pricing')}</Link>
        </nav>
        <div className="flex-1" />
        {/* 语言放在最左边一个位置：营销页是英文市场的落地页，访客落到一屏中文时
            需要当场看得见的出口。放在「登录 / 免费开始」之前，不跟 CTA 抢注意力。 */}
        <HeaderLocaleMenu />
        <Link href="/session/new" className="text-[15px] font-semibold text-muted hover:text-brand px-3 py-2">{t('auth.login.title')}</Link>
        <Link href="/registration/new" className="text-[15px] font-bold text-white grad-bg px-4 py-2 rounded-xl hover:opacity-90">{t('home.start')}</Link>
      </div>
    </header>
  )
}
